import { observer, useLocalStore } from 'mobx-react-lite';
import * as React from 'react';

import './slider.css';

interface IProps {
    slides: React.ReactElement[];
    currentIndex: number;
}

export const Slider = observer<IProps>((props) => {
    const reff = React.useRef<HTMLDivElement>(null);

    const store = useLocalStore(() => ({
        index: 0,
        scrollTo: (index: number) => {
            if (!reff.current) {
                return;
            }

            store.index = index;
            reff.current.scrollTo(index * 550, reff.current!.offsetTop);
        },
    }));

    React.useEffect(() => {
        store.scrollTo(props.currentIndex);
    }, [props.currentIndex, store]);

    return (
        <>
            <div className='slider' ref={reff}>
                <div className='slider-content'>
                    {props.slides}
                </div>
            </div>
        </>
    );
});
